<div class="sticky-top">
  <base-no-connection-banner></base-no-connection-banner>
  <base-up-to-date-app *ngIf="checkForUpdates"></base-up-to-date-app>
  <base-customer-onboarding-light-banner
    [logo]="env.application.logo"
    [application]="env.application.app"
  ></base-customer-onboarding-light-banner>
</div>
<base-spinner></base-spinner>
<base-toast-alerts></base-toast-alerts>
<router-outlet></router-outlet>
